'use strict';

var _objectSpread = require("/buildkite/builds/ip-10-0-0-210-ap-southeast-2-compute-internal-1/volaby-australia/volaby-frontend/client.campfire/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

let Container = require('./container');

let LazyResult, Processor;

class Document extends Container {
  constructor(defaults) {
    // type needs to be passed to super, otherwise child roots won't be normalized correctly
    super(_objectSpread({
      type: 'document'
    }, defaults));

    if (!this.nodes) {
      this.nodes = [];
    }
  }

  toResult(opts = {}) {
    let lazy = new LazyResult(new Processor(), this, opts);
    return lazy.stringify();
  }

}

Document.registerLazyResult = dependant => {
  LazyResult = dependant;
};

Document.registerProcessor = dependant => {
  Processor = dependant;
};

module.exports = Document;
Document.default = Document;